import Constant from '@/common/constant/Constant';
import { useEffect } from 'react';
import RenderTooltipTitles from './RenderTooltipTitles';
import FormInputWithOnChange from '../../common/form/input-with-onchange';
import Utils from '@/common/utils/utils';
import { useRecoilValue } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { I18n } from 'aws-amplify';
import { Tooltip } from '@material-ui/core';

export default function TextInput(props) {
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);

    let limitValue = corporationDetail?.limitValue;

    let formType = props.formType;
    let defaultValue = '';

    let autoDisableFields = ['ticketId']

    switch (true && !props.defaultValue) {
        case props.data.sysField === 'outline' && formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.OUTLINE;
            break;
        case props.data.sysField === 'outline' &&
            formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST_CUSTOMER.OUTLINE;
            break;
        case props.data.sysField === 'outline' && formType === Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.EXTERNAL_DESK_REQUEST.OUTLINE;
            break;
        case props.data.sysField === 'outline' && formType === Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.REQUEST_EXTERNAL_CUSTOMER.OUTLINE;
            break;

        case props.data.sysField === 'category' && formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.CATEGORY;
            break;
        case props.data.sysField === 'category' && formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST.CATEGORY;
            break;
        case props.data.sysField === 'category' &&
            formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER:
            defaultValue = 'ゲストカスタマー登録';
            break;
        case props.data.sysField === 'category' && formType === Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.EXTERNAL_DESK_REQUEST.CATEGORY;
            break;
        case props.data.sysField === 'category' && formType === Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.REQUEST_EXTERNAL_CUSTOMER.CATEGORY;
            break;
        default:
            defaultValue = props.defaultValue ? props.defaultValue : '';
            break;
    }

    if (props.defaultValue || props.isDraft) {
        defaultValue = props.defaultValue ? props.defaultValue : '';
    }

    useEffect(() => {
        registerAndSetValue();
    }, []);

    useEffect(() => {
        registerAndSetValue();
    }, [defaultValue]);

    const registerAndSetValue = () => {
        if (!props?.name) {
            return;
        }

        if (props.register) {
            props.register(props?.name, {
                onChange: e => {}
            });
        }
        if (props.setValue) {
            props.setValue(props?.name, defaultValue);
        }
    };
    const handleEditTicket = e => {
        if (props?.setIsEdited) {
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket()
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
        }
    };

    const renderInstruction = () => {
        if (!props?.isSystemSDAutoForm) return '';
        if (props.data.sysField !== Constant.SYS_FIELD.OUTLINE) return '';
        let instruction = I18n.get('MSG-SD-INTRUCTION-SCRIPT-TITLE');

        return instruction;
    }

    return (
        <div className={'form-addTicket'}>
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? 
                    <RenderTooltipTitles {...props}/> :
                    <label className="form-addTicket-label w-f100">
                        {props?.data?.sysField === 'guestProject' && formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST ? I18n.get('USER04BTN038') : props?.label}{' '}
                        {props.data.structure.required && <span className="required">*</span>}
                    </label>
                }
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
                
            </div>
            
            <div className="form-addTicket-input">
                <FormInputWithOnChange
                    name={props?.name}
                    className="form-control-input form-control-wrapInput form-control-hg40"
                    variant="outlined"
                    defaultValue={defaultValue}
                    autoComplete="off"
                    required={props?.required}
                    errorlist={props?.errorlist}
                    disabled={
                        props.data.structure.publicForCustomer == 2 ||
                        autoDisableFields.includes(props.data?.sysField) ||
                        props.viewFromProjectOfEscalateTicket ||
                        !Utils.isEmptyString(props.detailTicket?.deletedAt)
                        || props.hasEditFieldPermissions === false 
                    }
                    data-cy="render-field-txt-input"
                    onPaste={handleEditTicket}
                    onChange={e => handleEditTicket(e)}
                    isDisableOnBlur={props.isDisableOnBlur ? props.isDisableOnBlur : false}
                    instruction={renderInstruction()}
                />
            </div>
        </div>
    );
}